import React from 'react';

import { useFetchResults } from '../../../../controllers/results';
import { useSpotlightPrefetch } from '../../../../controllers/spotlight';

export const FetchResults = () => {
	useFetchResults();
	return null;
};

export const RegisterHooksWithNewFilters = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	useSpotlightPrefetch();
	return <>{children}</>;
};
